import { render, staticRenderFns } from "./TimeRemaining.vue?vue&type=template&id=2ed82515&scoped=true&"
import script from "./TimeRemaining.vue?vue&type=script&lang=js&"
export * from "./TimeRemaining.vue?vue&type=script&lang=js&"
import style0 from "./TimeRemaining.vue?vue&type=style&index=0&id=2ed82515&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed82515",
  null
  
)

export default component.exports